<script setup lang="ts">
// Bandeau affiché aux seuls utilisateurs du domaine historique
// diagnosticrapid.fr. Volontairement impossible à fermer : il reste tant que
// l'utilisateur n'est pas passé sur Inspexio.
import { computed, ref } from "vue";
import { useTranslation } from "i18next-vue";
import { trackAppFeature } from "@/analytics/app-analytics";
import { formatMigrationDeadline } from "@/brand/migration";
import BrandMigrationModal from "./BrandMigrationModal.vue";

const { t, i18next } = useTranslation();

const showModal = ref(false);
const deadline = computed(() => formatMigrationDeadline(i18next.language));

const openModal = () => {
  showModal.value = true;
  trackAppFeature("brand_migration_modal_opened");
};
</script>

<template>
  <button
    type="button"
    class="brand-migration-banner d-flex align-items-center gap-3 w-100 px-3 py-2"
    @click="openModal"
  >
    <i class="bi-megaphone-fill fs-5 flex-shrink-0" aria-hidden="true" />
    <span class="d-flex flex-column flex-grow-1 text-start">
      <strong>{{ t("brandMigration.bannerTitle") }}</strong>
      <span class="brand-migration-banner__text">
        {{
          deadline
            ? t("brandMigration.bannerTextDeadline", { date: deadline })
            : t("brandMigration.bannerText")
        }}
      </span>
    </span>
    <span class="brand-migration-banner__cta flex-shrink-0">
      {{ t("brandMigration.bannerCta") }}
      <i class="bi-chevron-right" aria-hidden="true" />
    </span>
  </button>

  <BrandMigrationModal v-model="showModal" />
</template>

<style lang="scss" scoped>
.brand-migration-banner {
  border: none;
  background-color: var(--bs-primary);
  // Blanc littéral, comme le bouton primaire : --bs-white devient gris foncé
  // en mode sombre.
  color: white;
  font-size: 0.9rem;
  line-height: 1.3;
  cursor: pointer;

  &__text {
    font-size: 0.8rem;
    opacity: 0.9;
  }

  &__cta {
    padding: 0.35rem 0.75rem;
    border: 1px solid white;
    border-radius: 999px;
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
  }

  &:hover &__cta,
  &:focus-visible &__cta {
    background-color: white;
    color: var(--bs-primary);
  }
}

// Petits écrans : le bandeau entier reste cliquable, le bouton se réduit à
// son chevron.
@media (max-width: 480px) {
  .brand-migration-banner__cta {
    padding: 0.35rem 0.5rem;
    font-size: 0;

    i {
      font-size: 0.8rem;
    }
  }
}
</style>
